import React, { useState, useMemo, useEffect} from 'react';
import styled from 'styled-components';
import { throttle } from 'lodash';

import Navigation from '../components/commons/organisms/Navigation';
import LoginForm from '../components/login/organisms/LoginForm';
import APIService from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SOFT_TOMATO } from '../components/colors';
import usePageView from '../hooks/use-page-view';
import { MIXPANEL_ACTION, MIXPANEL_PAGE } from '../utils/constants';
import MixpanelService from '../utils/mixpanel';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;

  @media(min-width: 768px) {
    max-width: 1200px; /* or 1280px */
    margin: 0 auto;
    padding: 1rem 1rem; /* optional side padding */
    flex-direction: row-reverse;
  }
`;

const Title = styled.div`
  p {
    font-family: 'Poppins-SemiBold';
    font-size: 1rem;
    margin: 0 0;
  }
`;

const Subtitle = styled.div`
  p {
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    margin: 0 0;
  }
`;

const LeftPane = styled.div`
  // border: 1px solid red;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
 

const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const BigLogo = styled.div`
  height: 180px;
  img {
    height: 180px;
    object-fit: cover;
  }
`;

const ErrorLabel = styled.div`
  p {
    font-family: 'Poppins-SemiBold';
    font-size: 0.8rem;
    margin: 0 0;
    color: red;
    margin-top: 1rem;
  }
`;

const ButtonRegister = styled.div`
  p {
    text-align: center;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    text-decoration: underline;
    color: ${SOFT_TOMATO}
  }
`;

const Login = () => {

  const navigate = useNavigate();
  const {
    refreshUser,
    user
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState<string | null>();

  usePageView(MIXPANEL_PAGE.LOGIN);
  
  const loginCustomer = async (payload: any) => {
    try {
      setIsLoading(true);
      await APIService.login(payload);
      setIsLoading(false);
      refreshUser();
      navigate('/shop');
    } catch (e: any) {
      setIsLoading(false);
      switch (e.status) {
        case 404: 
          setLoginError('EMAIL ADDRESS/PASSWORD IS INCORRECT'.toUpperCase());
          break;
        default:
          setLoginError('UNKNOWN ERROR OCCURED')
      }
    } finally {
      setIsLoading(false);
    }
  }

  const throttleOnSubmit = useMemo(() => throttle((payload: any) => {
    loginCustomer(payload)
  }, 2000), []); 

  useEffect(() => {
    if (user) {
      navigate('/shop')
    }
  }, [user])

  return (
     <>
      <Navigation />
      <Container>
        <LeftPane>
          <BigLogo>
            <img src={require('../assets/hg-logo.png')} />
          </BigLogo>       
        </LeftPane>

        <RightPane>
          <Title>
            <p>{'Login to Your Account'.toUpperCase()}</p>
          </Title>
          <Subtitle>
            <p>{'Securely access your saved items, past purchases, and faster checkout.'.toUpperCase()}</p>
          </Subtitle>
          { loginError && 
            <ErrorLabel>
              <p>
                {loginError}
              </p>
            </ErrorLabel>
          }
          <LoginForm 
            disabled={isLoading}
            onSubmit={(email, password) => {
              MixpanelService.track(
                `${MIXPANEL_PAGE.LOGIN} - ${MIXPANEL_ACTION.BUTTON_CLICK}`, {
                  item: 'Login',
                }
              );
              throttleOnSubmit({
                email,
                password
              })
            }}
          />
          <ButtonRegister>  
            <p onClick={() => {
              MixpanelService.track(
                `${MIXPANEL_PAGE.LOGIN} - ${MIXPANEL_ACTION.BUTTON_CLICK}`, {
                  item: 'Register',
                }
              );
              navigate('/register');
            }}>
              CREATE AN ACCOUNT
            </p>
          </ButtonRegister>
        </RightPane>
      </Container>
    </>
  )
}

export default Login;

